import React from 'react';
import { UnderConstruction as UC } from '@leegality/leegality-react-component-library';
import { Image, ImageKeys } from '@components/image';

const AccessDenied = () => {
  return (
    <UC
      title="Access Denied"
      message="You don't have permission to access this page"
      renderImage={() => <Image imgKey={ImageKeys.AccessDenied} />}
    />
  );
};

export default AccessDenied;
